// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"abd28ce0","592":"afa473d8","856":"218205eb"}[chunkId] + ".chunk.js";
};